'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var console = window.console || {
    warning: function warning(string) {}
};
var warning = function warning(ok, text) {
    return ok ? true : console.warning(text);
};
/**
 * Switch is dumb and magical, but very useful. It only works with components that have a very specific set of props.
 * This is a copy of Switch from rect-router v4, hacked.
 */

var Switch = function (_React$Component) {
    _inherits(Switch, _React$Component);

    function Switch() {
        _classCallCheck(this, Switch);

        return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
    }

    _createClass(Switch, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            warning(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

            warning(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        }
    }, {
        key: 'render',
        value: function render() {
            var route = this.context.router.route;
            var routes = this.context.routes;
            var children = this.props.children;

            var location = this.props.location || route.location;

            var match = void 0,
                child = undefined;

            _react2.default.Children.forEach(children, function (element) {
                if (!_react2.default.isValidElement(element)) return;

                var _element$props = element.props,
                    pathProp = _element$props.path,
                    exact = _element$props.exact,
                    strict = _element$props.strict,
                    from = _element$props.from;
                var name = element.props.name; // MODIFIED

                var path = pathProp || from || routes[name]; // MODIFIED


                if (match == null) {
                    child = element;
                    match = path ? (0, _reactRouterDom.matchPath)(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
                }
            });

            return match && child ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
        }
    }]);

    return Switch;
}(_react2.default.Component);

Switch.contextTypes = {
    routes: _propTypes2.default.object, // MODIFIED
    router: _propTypes2.default.shape({
        route: _propTypes2.default.object.isRequired
    }).isRequired
};
exports.default = Switch;